import { render, staticRenderFns } from "./ModifyDetail.vue?vue&type=template&id=f055cd3c"
import script from "./ModifyDetail.vue?vue&type=script&lang=js"
export * from "./ModifyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports